<template>
    <div>

        <div class="position-relative">
            <!-- shape Hero -->
        <section class="section section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-1 bg-gradient-info shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container pt-0 pb-5">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-lg-2 ml-lg-auto">
                        <div class="position-relative pl-md-5">
                            <img src="img/brand/guidance.svg" class="img-center img-fluid">
                        </div>
                    </div>
                    <div class="col-lg-6 order-lg-1">
                        <div class="d-flex px-3">
                            <div class="pl-4">
                                <h5 class="display-3 text-white">Guidance for Stakeholders</h5>
                                <p class="text-white">The success and quality of a traineeship abroad rely on the commitment of many different stakeholders. Quality+ is offering some guidance to the different stakeholders.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
            <!-- 1st Hero Variation -->
        </div>
        <section class="section section-lg">
            <div class="container">
                <div class="row">
                    <!-- <div class="col-md-1 mb-5 mb-md-0">
                        <div>
                                <img v-lazy="'img/brand/doc_agree2.svg'" class="card-img">
                        </div>
                    </div> -->
                    <div class="col-md-6 mb-5 mb-lg-0">
                        <card class="border-0 box bg-secondary" shadow body-classes="py-5 d-flex flex-column">
                            <h6 class="text-primary">Online Guide for Teachers</h6>
                            <p class="description mt-3">The Online Guide for Teachers gives a deeper understanding of mobility projects for VET learners within the Erasmus+ programme and explains what the teacher’s key roles and responsibilities.</p>
                            <base-button @click="show" tag="a" href="#" type="primary" class="mt-5">
                                View the Guide
                            </base-button>
                        </card>
                    </div>
                    <!-- <div class="col-md-1 mb-5 mb-md-0">
                        <div>
                                <img v-lazy="'img/brand/doc_agree.svg'" class="card-img">
                        </div>
                    </div> -->
                    <div class="col-md-6 mb-5 mb-lg-0">
                        <card class="border-0 box bg-secondary" shadow body-classes="py-5 d-flex flex-column">
                            <h6 class="text-primary">Guide for Host Companies</h6>
                            <p class="description mt-3">The Guide for Host Companies answers 77 questions that a host company may have in order to manage a VET traineeship before, during and after it takes place.</p>
                            <base-button tag="a" href="https://firebasestorage.googleapis.com/v0/b/adeptprod-11172.appspot.com/o/docs%2Ffinal%2FQ%2B_GuideforHC_A5_Digital_Final.pdf?alt=media&token=6f6ede5c-0fe3-4649-8de2-860cda4348ac" type="primary" class="mt-5" target="_blank">
                                Download the Guide
                            </base-button>
                        </card>
                    </div>
                </div>
                <div class="row mt-5">
                    <!-- <div class="col-md-2 mb-5 mb-md-0">
                        <div>
                                <img v-lazy="'img/brand/doc_agree.svg'" class="card-img">
                        </div>
                    </div> -->
                    <div class="col-md-6 mb-5 mb-lg-0">
                        <card class="border-0 box bg-secondary" shadow body-classes="py-5 d-flex flex-column">
                            <h6 class="text-primary">A Brief Introduction for VET Traineeships for HC</h6>
                            <p class="description mt-3">The video is intended to host companies, specifically to managers and staff, as to give them an
understanding upon the objectives of a mobility for VET learners.</p>
                            <base-button tag="a" @click="show_third" href="#" type="primary" class="mt-5">
                                View the Video
                            </base-button>
                        </card>
                    </div>
                    <div class="col-md-6 mb-lg-0">
                        <card class="border-0 box bg-secondary" shadow body-classes="py-5 d-flex flex-column">
                            <h6 class="text-primary">Host Companies Brochure</h6>
                            <p class="description mt-3">The Host Companies Brochure presents the VET traineeship and target to the Host Companies.</p><br>
                            <base-button tag="a" href="https://firebasestorage.googleapis.com/v0/b/adeptprod-11172.appspot.com/o/docs%2FQ%2B_HC_Brochure_Trifold_Print_Final.pdf?alt=media&token=f7836162-8440-4491-b3e3-b3d6040e8a91" type="primary" class="mt-5">
                                Download the Brochure
                            </base-button>
                        </card>
                    </div>
                </div>
                <div class="row mt-5">
                    <!-- <div class="col-md-2 mb-5 mb-md-0">
                        <div>
                                <img v-lazy="'img/brand/doc_agree.svg'" class="card-img">
                        </div>
                    </div> -->
                    <div class="col-md-6 mb-lg-0">
                        <card class="border-0 box bg-secondary" shadow body-classes="py-5 d-flex flex-column">
                            <h6 class="text-primary">Student Commitment Video</h6>
                            <p class="description mt-3">The video is intended to VET learners and presents the most essential aspects of the Student
Commitment Form.</p><br>
                            <base-button tag="a" href="#" @click="show_forth" type="primary" class="mt-5">
                                View the Video
                            </base-button>
                        </card>
                    </div>
                    <div class="col-md-6 mb-lg-0">
                        <card class="border-0 box bg-secondary" shadow body-classes="py-5 d-flex flex-column">
                            <h6 class="text-primary">VET Learners Brochure</h6>
                            <p class="description mt-3">The VET Learners Brochure presents the VET traineeship and target to the learners.</p><br>
                            <base-button tag="a" href="https://firebasestorage.googleapis.com/v0/b/adeptprod-11172.appspot.com/o/docs%2FQ%2B_Students_Brochure_Trifold_Print_Final.pdf?alt=media&token=8801d0fe-3691-4bf0-aa64-9f3528b0cb7a" type="primary" class="mt-5">
                                Download the Brochure
                            </base-button>
                        </card>
                    </div>
                </div>
                <div class="row mt-5">
                    <!-- <div class="col-md-2 mb-5 mb-md-0">
                        <div>
                                <img v-lazy="'img/brand/doc_agree.svg'" class="card-img">
                        </div>
                    </div> -->
                    <div class="col-md-6 mb-5 mb-lg-0">
                        <card class="border-0 box bg-secondary" shadow body-classes="py-5 d-flex flex-column">
                            <h6 class="text-primary">Check List for IOs</h6>
                            <p class="description mt-3">The Check List give the intermediary organisation an overview of the most important aspect to discuss with host companies when planning a VET traineeship.</p>
                            <base-button tag="a" href="https://firebasestorage.googleapis.com/v0/b/adeptprod-11172.appspot.com/o/docs%2FQ%2B_Checklist_A4_OfficePrint_Final.pdf?alt=media&token=f34a5c3c-fd28-470e-b4a8-f190a6e96a22" type="primary" class="mt-5" target="_blank">
                                Download the Check List
                            </base-button>
                        </card>
                    </div>
                </div>
                <!-- <div class="row mt-5">
                    <div class="col-md-2 mb-5 mb-md-0">
                        <div>
                                <img v-lazy="'img/brand/doc_agree2.svg'" class="card-img">
                        </div>
                    </div>
                    <div class="col-md-10 mb-5 mb-lg-0">
                        <card class="border-0 box bg-secondary" shadow body-classes="py-5 d-flex flex-column">
                            <h6 class="text-primary">Check List for IOs</h6>
                            <p class="description mt-3">The Check List give the intermediary organisation an overview of the most important aspect to discuss with host companies when planning a VET traineeship.</p>
                            <base-button tag="a" href="#" type="primary" class="mt-5">
                                Download the Check List
                            </base-button>
                        </card>
                    </div>
                </div> -->
                <!-- <div class="row mt-5">
                    <div class="col-md-2 mb-5 mb-md-0">
                        <div>
                                <img v-lazy="'img/brand/doc_agree2.svg'" class="card-img">
                        </div>
                    </div>
                    <div class="col-md-10 mb-5 mb-lg-0">
                        <card class="border-0 box bg-secondary" shadow body-classes="py-5 d-flex flex-column">
                            <h6 class="text-primary">VET Learners Brochure</h6>
                            <p class="description mt-3">The VET Learners Brochure presents the VET traineeship and target to the learners.</p>
                            <base-button tag="a" href="#" type="primary" class="mt-5">
                                Download the Brochure
                            </base-button>
                        </card>
                    </div>
                </div> -->
                <modal height="auto" width="80%" name="my-second-modal">
                    <div>
                        <div class="player-container">
                            <Media 
                                :kind="'video'"
                                :controls="true"
                                :src="['https://firebasestorage.googleapis.com/v0/b/adeptprod-11172.appspot.com/o/docs%2Ffinal%2FOnline%20Guide%20for%20Teachers_VIDEO.mp4?alt=media&token=49266a73-f5d8-4d0b-b1d0-99e71e8c162d']"
                                :style="{width: '100%'}"
                                :autoplay="true"
                                :loop="false"
                            >
                            </Media>
                        </div>
                    </div>
                </modal>
                <modal height="auto" width="80%" name="my-third-modal">
                    <div>
                        <div class="player-container">
                            <Media 
                                :kind="'video'"
                                :controls="true"
                                :src="['https://firebasestorage.googleapis.com/v0/b/adeptprod-11172.appspot.com/o/docs%2Ffinal%2FA%20Brief%20Introduction%20for%20VET%20Traineeships%20for%20HC.mp4?alt=media&token=3f8af0b1-8ce7-4c24-9da6-c3f7f10e1b05']"
                                :style="{width: '100%'}"
                                :autoplay="true"
                                :loop="false"
                            >
                            </Media>
                        </div>
                    </div>
                </modal>
                <modal height="auto" width="80%" name="my-forth-modal">
                    <div>
                        <div class="player-container">
                            <Media 
                                :kind="'video'"
                                :controls="true"
                                :src="['https://firebasestorage.googleapis.com/v0/b/adeptprod-11172.appspot.com/o/docs%2Ffinal%2FStudent%20Commitment%20Video.mp4?alt=media&token=e0829227-6bbf-4db2-8058-919c61470f66']"
                                :style="{width: '100%'}"
                                :autoplay="true"
                                :loop="false"
                            >
                            </Media>
                        </div>
                    </div>
                </modal>
            </div>
        </section>

    </div>
</template>

<script>
import VueCoreVideoPlayer from 'vue-core-video-player'
import Media from '@dongido/vue-viaudio'
export default {
  name: "home",
  components: {
      Media
  },
  methods: {
        show () {
            this.$modal.show('my-second-modal');
        },
        hide () {
            this.$modal.hide('my-second-modal');
        },
        show_third () {
            this.$modal.show('my-third-modal');
        },
        hide_third () {
            this.$modal.hide('my-third-modal');
        },
        show_forth () {
            this.$modal.show('my-forth-modal');
        },
        hide_forth () {
            this.$modal.hide('my-forth-modal');
        }
  }
};
</script>
